
window.addEventListener("DOMContentLoaded", function() {
  
    TranslatePaymentStatusLanguage(); // account.liquid

    function TranslatePaymentStatusLanguage() {
      
        var OrderFinancialValues = document.getElementsByClassName('order_financial_value');
        var OrderFulfillmentValues = document.getElementsByClassName('order_fulfillment_value');

        var language = [
            ['pending', '決済処理中'],
            ['paid', '支払い済み'],
            ['voided', 'キャンセル済み'],
            ['unfulfilled', '未発送'],
            ['fulfilled', '発送済み'],
        ];

        for (var i = 0; i < OrderFinancialValues.length; i++) {
            for (var j = 0; j < language.length; j++) {
                if (language[j][0] === OrderFinancialValues[i].textContent) {
                    OrderFinancialValues[i].textContent = language[j][1];
                    break;
                }
            }
        }

        for (var i = 0; i < OrderFulfillmentValues.length; i++) {
            for (var j = 0; j < language.length; j++) {
                if (language[j][0] === OrderFulfillmentValues[i].textContent) {
                    OrderFulfillmentValues[i].textContent = language[j][1];
                    break;
                }
            }
        }
      
    }
  
});


window.addEventListener("DOMContentLoaded", function() {
  
    ChangeSoldoutTagColor(); // product-listing.liquid, product-template.liquid

    function ChangeSoldoutTagColor() {
      
        var SoldoutTag = document.getElementsByClassName('soldout');   // 商品一覧ページのタグ
        var UrikireTag = document.getElementsByClassName('urikire');   // 商品ページ詳細のタグ

        for (var i = 0; i < SoldoutTag.length; i++) {
            if (SoldoutTag[i].innerText == "完売") {
                SoldoutTag[i].style.backgroundColor = 'red';
            }
        }

        for (var i = 0; i < SoldoutTag.length; i++) {
            if (SoldoutTag[i].innerText == "生産中") {
                SoldoutTag[i].style.backgroundColor = 'green';
            }
        }

        for (var i = 0; i < SoldoutTag.length; i++) {
            if (SoldoutTag[i].innerText != "完売" && SoldoutTag[i].innerText != "生産中" ) {
                SoldoutTag[i].style.backgroundColor = '#E6B422';  // 黄色にする
            }
        }

        for (var i = 0; i < UrikireTag.length; i++) {
            if (UrikireTag[i].innerText == "完売") {
                UrikireTag[i].style.backgroundColor = 'red';
            }
        }

        for (var i = 0; i < UrikireTag.length; i++) {
            if (UrikireTag[i].innerText == "生産中") {
                UrikireTag[i].style.backgroundColor = 'green';
            }
        }

        for (var i = 0; i < UrikireTag.length; i++) {
            if (UrikireTag[i].innerText != "完売" && UrikireTag[i].innerText != "生産中" ) {
                UrikireTag[i].style.backgroundColor = '#E6B422';  // 黄色にする
            }
        }
      
    }
  
});


window.addEventListener("DOMContentLoaded", function() {
  
    SortAllItemList(); // navigation.liquid

    function SortAllItemList() {
      
        var CategoryDropdownLink = document.querySelectorAll(".submenu a");
        
        CategoryDropdownLink.forEach(link => {
            if (link.href.includes("collections/all")) {
                link.href += "/?sort_by=created-descending";
            }
        });
      
    }
  
});


document.addEventListener('DOMContentLoaded', function() {
  
    SortAllItemListMobile(); // mobile-navigation.liquid

    function SortAllItemListMobile() {
      
        var CategoryDropdownLink = document.querySelectorAll("#accordion a");
        
        CategoryDropdownLink.forEach(link => {
            if (link.href.includes("collections/all")) {
                link.href += "/?sort_by=created-descending";
            }
        });
      
    }
  
});


window.addEventListener('DOMContentLoaded', function() {
  ChangeTextRefundPolicy();

  function ChangeTextRefundPolicy() {
    // ページ内のすべてのテキストノードを取得
    const treeWalker = document.createTreeWalker(
      document.body,
      NodeFilter.SHOW_TEXT,
      null,
      false
    );

    // 各テキストノードに対して置換処理を行う
    while (treeWalker.nextNode()) {
      const node = treeWalker.currentNode;
      if (node.nodeValue.includes('返金ポリシー')) {
        node.nodeValue = node.nodeValue.replace(/返金ポリシー/g, '返品・交換ポリシー');
      }
    }
  }
});

window.addEventListener('DOMContentLoaded', function() {

  HideBackGroundButtonColorInSlider();

  function HideBackGroundButtonColorInSlider() {
  
    const ctaLinks = document.querySelectorAll('.cta a');
    ctaLinks.forEach(link => {
      
      if (link.textContent.trim() === '隠す') {
        
        const captionInners = link.closest('.caption-inners');
        if (captionInners) {
          captionInners.remove();
        }
        
      }
      
    });

  }
  
});


// window.addEventListener("DOMContentLoaded", function() {

//     UndisplayNewItemFromProductList(); // product-listing.liquid

//     function UndisplayNewItemFromProductList() {

      // 商品リストからアイテムを非表示にする
      // if (window.location.href.includes('/collections/')) {
      //     const elements = document.querySelectorAll('[data-alpha="【Alexander】袖フリル付き2WAYシャツ'); // 消したい商品名を入力する
      //     elements.forEach(element => {
      //         element.style.display = "none";
      //     });
      // }

      // // 検索ボックスからアイテムを非表示にする
      // if (window.location.href.includes('/search?')) {
      //   document.querySelectorAll('.product-details h3').forEach(el => {
      //       if (el.textContent.includes('【Alexander】袖フリル付き2WAYシャツ')) { // 消したい商品名を入力する
      //           el.closest('.product-index').style.display = 'none';
      //       }
      //   });
      
//     }

// });


// window.addEventListener('DOMContentLoaded', function() {

//     setTimeout(function() { // 他のアプリよりも後に実行するために0.025秒待機する
//         CloseAddCartButton();  // product-form.liquid
//     }, 25);

//     function CloseAddCartButton() {

//         var now = new Date();
//         var unlock_date = new Date('2024-10-30T21:00:00'); 　// 時刻フォーマット 2024年-00月-00日T00時:00分:00秒 １桁の0を忘れない

//         if (now < unlock_date) { // 現在時刻がアンロックの時間と同じ時刻になった瞬間に開く
      
//           var current_url = window.location.href;
  
//           if (current_url.includes("products/hoo")) {
//               var AddCartButton = document.getElementById('AddToCart');
//               AddCartButton.value = "Coming soon ...";
//               AddCartButton.style.backgroundColor = "gray";
//             　AddCartButton.disabled = true;  // このボタンを押すすべてのイベントを無効化する

//               var CartDrawer = document.getElementById('CartDrawer');
//               CartDrawer.style.visibility = "hidden";
            
//           }

//         }
      
//     }
  
// });


// window.addEventListener('DOMContentLoaded', function() {
  
//     setTimeout(function() {
//         HideComingSoonBadge(); // product-form.liquid
//     }, 1000);

//     function HideComingSoonBadge() {

//         var current_url = window.location.href;

//         if (current_url.includes("products")) {
//             var comingSoonBadges = document.querySelectorAll(".comingSoonBadge2");
            
//             comingSoonBadges.forEach(function(badge) {
//                 badge.style.visibility = "hidden";
//             });
//         }

//     }
  
// });

/* ===== Sticky ATC Bar 20260529===== */
(function() {
  // 商品ページ以外では何もしない
  if (!document.querySelector('.product-template, .product, [data-section-type="product"]')) return;

  // バーのHTML を body に挿入
  var barHTML = '<div id="sticky-atc-bar" class="sticky-atc-bar" aria-hidden="true">'
    + '<div class="sticky-atc-bar__inner">'
    + '<div class="sticky-atc-bar__info">'
    + '<div class="sticky-atc-bar__title" id="sticky-atc-title"></div>'
    + '<div class="sticky-atc-bar__row2">'
    + '<span class="sticky-atc-bar__variant" id="sticky-atc-variant"></span>'
    + '<span class="sticky-atc-bar__price" id="sticky-atc-price"></span>'
    + '</div>'
    + '</div>'
    + '<button id="sticky-atc-btn" class="sticky-atc-bar__btn" type="button">カートに追加</button>'
    + '</div>'
    + '</div>';

  document.body.insertAdjacentHTML('afterbegin', barHTML);

  var bar       = document.getElementById('sticky-atc-bar');
  var stickyBtn = document.getElementById('sticky-atc-btn');
  var titleEl   = document.getElementById('sticky-atc-title');
  var variantEl = document.getElementById('sticky-atc-variant');
  var priceEl   = document.getElementById('sticky-atc-price');

  function getMainBtn() {
    return document.querySelector('[name="add"], .product-form__submit, .btn--add-to-cart, button[data-add-to-cart]');
  }

  function formatMoney(cents) {
    return new Intl.NumberFormat('ja-JP', { style: 'currency', currency: 'JPY' }).format(cents / 100);
  }

  // 初期値をページから取得
  function initBar() {
    // 商品名
    var titleSource = document.querySelector('.product__title, .product-single__title, h1.title, h1');
    if (titleSource && titleEl) titleEl.textContent = titleSource.textContent.trim();

    // 初期バリアント情報はShopifyのグローバル変数から取得
    if (window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.selectedVariantId) {
      // variant:changed イベントで更新されるので初期表示は空でもOK
    }

    // メタタグから初期価格取得
    var priceMeta = document.querySelector('meta[property="og:price:amount"]');
    if (priceMeta && priceEl) {
      priceEl.textContent = '¥' + Number(priceMeta.content).toLocaleString('ja-JP');
    }

    // メインボタンの初期状態を反映
    var mainBtn = getMainBtn();
    if (mainBtn && stickyBtn) {
      stickyBtn.disabled = mainBtn.disabled;
      if (mainBtn.disabled) stickyBtn.textContent = '売り切れ';
    }
  }

  // スクロール監視
  function onScroll() {
    var mainBtn = getMainBtn();
    if (!mainBtn) return;
    var rect = mainBtn.getBoundingClientRect();
    var isHidden = rect.bottom < 0 || rect.top > window.innerHeight;
    if (isHidden) {
      bar.classList.add('is-visible');
      bar.setAttribute('aria-hidden', 'false');
    } else {
      bar.classList.remove('is-visible');
      bar.setAttribute('aria-hidden', 'true');
    }
  }

  window.addEventListener('scroll', onScroll, { passive: true });

  // スティッキーボタン → メインフォームをクリック
  if (stickyBtn) {
    stickyBtn.addEventListener('click', function() {
      var mainBtn = getMainBtn();
      if (mainBtn) mainBtn.click();
    });
  }

  // バリアント変更時に更新
  document.addEventListener('variant:changed', function(e) {
    var variant = e.detail && e.detail.variant;
    if (!variant) return;

    if (variantEl && variant.options) {
      variantEl.textContent = variant.options.join(' / ');
    }

    if (priceEl) {
      var html = '';
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        html += '<s>' + formatMoney(variant.compare_at_price) + '</s> ';
      }
      html += formatMoney(variant.price);
      priceEl.innerHTML = html;
    }

    if (stickyBtn) {
      stickyBtn.disabled = !variant.available;
      stickyBtn.textContent = variant.available ? 'カートに追加' : '売り切れ';
    }
  });

  // DOM読み込み完了後に初期化
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initBar);
  } else {
    initBar();
  }
})();
/* ===== /Sticky ATC Bar ===== */


// Powerful Form Builder
// Powerful Form Builder

/**
 * 交換・返品の選択に応じて項目を表示
 */
function toggleExchangeFields() {
    const form = document.querySelector('.globo-form-id-149569');
    if (!form) return;

    const exchange = form.querySelector('input[value="交換したい"]');
    const returned = form.querySelector('input[value="返品したい"]');

    const isExchange = exchange && exchange.checked;
    const isReturn = returned && returned.checked;

    const file = form.querySelector('[data-element-id="file2-1"]');
    const schedule = form.querySelector('[data-element-id="text-4"]');

    if (file) {
        file.style.display = (isExchange || isReturn) ? 'block' : 'none';
    }

    if (schedule) {
        schedule.style.display = isExchange ? 'block' : 'none';
    }

    switchParagraphByCheckbox();

    const fileInput = form.querySelector('[data-element-id="file2-1"] input[type="file"]');

    if (fileInput) {
        fileInput.required = isExchange || isReturn;
        fileInput.setAttribute('aria-required', (isExchange || isReturn) ? 'true' : 'false');
    }
}


/**
 * 交換・返品はどちらか一方のみ選択可能
 */
function limitExchangeCheckbox(currentCheckbox) {
    const form = document.querySelector('.globo-form-id-149569');
    if (!form) return;

    const checkboxes = form.querySelectorAll(
        '[data-element-id="checkbox-1"] input[type="checkbox"]'
    );

    if (currentCheckbox.checked) {
        checkboxes.forEach(function(checkbox) {
            if (checkbox !== currentCheckbox) {
                checkbox.checked = false;
            }
        });
    }

    toggleExchangeFields();
}


/**
 * paragraph-1 の内容を「%--cut--%」で分割し、
 * 交換・返品の選択に応じて表示内容を切り替える
 */
function switchParagraphByCheckbox() {
    const form = document.querySelector('.globo-form-id-149569');
    if (!form) return;

    const exchange = form.querySelector('input[value="交換したい"]');
    const returned = form.querySelector('input[value="返品したい"]');

    const isExchange = exchange && exchange.checked;
    const isReturn = returned && returned.checked;

    const paragraphWrap = form.querySelector('[data-element-id="paragraph-1"]');
    const paragraph = paragraphWrap
        ? paragraphWrap.querySelector('.globo-paragraph') || paragraphWrap
        : null;

    if (!paragraph || !paragraphWrap) return;

    if (!paragraph.dataset.originalHtml) {
        paragraph.dataset.originalHtml = paragraph.innerHTML;
    }

    const parts = paragraph.dataset.originalHtml.split('%--cut--%');
    const exchangeHtml = parts[0] ? parts[0].trim() : '';
    const returnHtml = parts[1] ? parts[1].trim() : '';

    if (isExchange) {
        paragraph.innerHTML = exchangeHtml;
        paragraphWrap.style.display = 'block';
    } else if (isReturn) {
        paragraph.innerHTML = returnHtml;
        paragraphWrap.style.display = 'block';
    } else {
        paragraphWrap.style.display = 'none';
    }
}


/**
 * 初期化
 */
function initPowerfulFormCustom() {
    document.addEventListener('change', function(e) {
        const target = e.target;

        if (
            target.matches('.globo-form-id-149569 [data-element-id="checkbox-1"] input[type="checkbox"]')
        ) {
            limitExchangeCheckbox(target);
        }

        if (target.closest('.globo-form-id-149569')) {
            toggleExchangeFields();
        }
    });

    toggleExchangeFields();
}


document.addEventListener('DOMContentLoaded', function() {
    initPowerfulFormCustom();

    setTimeout(toggleExchangeFields, 500);
    setTimeout(toggleExchangeFields, 1500);
});